import { render, staticRenderFns } from "./caddie_house.vue?vue&type=template&id=473c3cbe&scoped=true"
import script from "./caddie_house.vue?vue&type=script&lang=js"
export * from "./caddie_house.vue?vue&type=script&lang=js"
import style0 from "./caddie_house.vue?vue&type=style&index=0&id=473c3cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c3cbe",
  null
  
)

export default component.exports